export const environment = {
  production: true,
  //production urls
   BASE_API_URL_BACKEND: 'https://pulse.bluealtair.com:8080',
   BASE_API_URL_FRONTEND: 'https://pulse.bluealtair.com'
};

